exports.default = undefined;
const { extend } = require('vee-validate');

// Install rules
_default = extend('url', {
    validate(value) {
        return /^(https?:\/\/(?:www\.|(?!www))[^\s.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})$/.test(value);
    },
});

exports.default = _default;
